import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import RecurringEndDateModal from '@calendar/components/Modals/RecurringEndDateModal.vue'
import RecurringDayModal from '@calendar/components/Modals/RecurringDayModal.vue'
import { mapGetters, mapMutations } from 'vuex';
import * as types from '@calendar/store/types'
import * as dateutil from '@/util/date-helper'

@Component({
    components: { 
        RecurringEndDateModal,
        RecurringDayModal
    },
    computed: {
        ...mapGetters({
            value: types.CURRENT_CALENDAR_ITEM,
        })
    },
    methods: {
        ...mapMutations({
            setCurrentItem: types.CURRENT_CALENDAR_ITEM,
            setCurrentRecurring: types.CALENDAR_CURRENT_RECURRING
        })
    }
})
export default class RecurringContainer extends Vue {
    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //

    value!: calendar.CalendarItem;

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: M U T A T I O N S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    setCurrentItem!: (item: calendar.CalendarItem) => void;
    setCurrentRecurring!: (item: calendar.CalendarItemRecurrence) => void;

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    localRecurrence: calendar.CalendarItemRecurrence = {
        startDate: dateutil.uGetDateFormat('yyyy-MM-dd', new Date()),
        endDate: dateutil.uGetDateFormat('yyyy-MM-dd', dateutil.uGetDate(90)),
        ui_useRecurringButton: true,
        ui_useDefaultDate: true,
        ui_useRecurringDisplay: false,
        ui_useRecurring: false,
        ui_recurringType: 1,
        monthValue: (new Date().getMonth() + 1),
        firstDayOfWeekValue: 1,
        daysOfTheWeekArray: [] as number[],
        dayOfMonth: 1,
        ui_endType: '1',
        interval: 1,
    } as calendar.CalendarItemRecurrence;

    showDayModal: boolean = false // 요일 설정 모달
    showEndDateModal: boolean = false // 종료일 설정 모달
    typeChangeOpen: boolean = false // 타입 변경 오픈 여부
    showWeekText: any;
    isNotUsed: boolean = true // 사용 안함 여부
    RecurringType: string = '' // 타입 값
    dateUnitText: string[] = [
        '', 
        this.$t('W_Schedule_Day').toString(), 
        this.$t('W_Schedule_Week').toString(), 
        this.$t('W_Schedule_Month').toString(), 
        this.$t('W_Schedule_Year').toString()
    ]

    weeklist: { text: string; value: number; }[] = dateutil.uGetWeekArray([
        this.$t('W_Schedule_Sunday').toString(),
        this.$t('W_Schedule_Monday').toString(),
        this.$t('W_Schedule_Tuesday').toString(),
        this.$t('W_Schedule_Wednesday').toString(),
        this.$t('W_Schedule_Thursday').toString(),
        this.$t('W_Schedule_Friday').toString(),
        this.$t('W_Schedule_Saturday').toString(),
    ]);

    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: C O M P U T E D : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //

    get WeekText() {
        return this.showWeekText;
    }

    get GetMonthArray() {
        return dateutil.uGetMonthArray([
            this.$t('W_1M').toString(),
            this.$t('W_2M').toString(),
            this.$t('W_3M').toString(),
            this.$t('W_4M').toString(),
            this.$t('W_5M').toString(),
            this.$t('W_6M').toString(),
            this.$t('W_7M').toString(),
            this.$t('W_8M').toString(),
            this.$t('W_9M').toString(),
            this.$t('W_10M').toString(),
            this.$t('W_11M').toString(),
            this.$t('W_12M').toString(),
        ]);
    }

    get getSelectedStatus() : any {
        // 수정화면에서 들어왔을 때 저장된 정보로
        if(this.localRecurrence.ui_useRecurring){
            switch (this.localRecurrence.ui_recurringType) {
                case 1:
                    this.isNotUsed = false
                    return this.$t('W_Schedule_EveryDay').toString();
                case 2:
                    this.isNotUsed = false
                    return this.$t('W_Schedule_EveryWeek').toString();
                case 3:
                    this.isNotUsed = false
                    return this.$t('W_Schedule_EveryMonth').toString();
                case 4:
                    this.isNotUsed = false
                    return this.$t('W_Schedule_EveryYear').toString();
            }
        }
        else {
            if(this.RecurringType === ''){
                this.isNotUsed = true;
                return this.$t('사용_안_함').toString();
            }else{
                switch (this.RecurringType) {
                    case '1':
                        return this.$t('W_Schedule_EveryDay').toString();
                    case '2':
                        return this.$t('W_Schedule_EveryWeek').toString();
                    case '3':
                        return this.$t('W_Schedule_EveryMonth').toString();
                    case '4':
                        return this.$t('W_Schedule_EveryYear').toString();
                }
            }
        }
    }

    get getEndType() {
        if(this.localRecurrence.ui_endType)
        {
            switch(this.localRecurrence.ui_endType)
            {
                case '1':
                    this.localRecurrence.endDate = null;
                    return this.$t('종료일_지정안함').toString();
                case '2':
                    return this.localRecurrence.numberOfOccurrences + this.$t('W_Schedule_EndAfter').toString();
                case '3':
                    //this.localRecurrence.endDate = this.value.recurrence.endDate;
                    let EDate = this.localRecurrence.endDate?.split('T')[0];
                    return EDate + this.$t('종료').toString();
            }
        }
       
    }

    /**
     * 반복일정 설정 내용을 표시합니다
     */
    get getRecurrencePatternDisplay() {

        let beautifyStartTime;
        let beautifyEndTime;

        if(this.value.starttime && this.value.starttime.length >3) {
            beautifyStartTime =  this.value.starttime.substr(0, this.value.starttime.length -3);
        }
        if(this.value.endtime && this.value.endtime.length >3) {
            beautifyEndTime = this.value.endtime.substr(0, this.value.endtime.length -3);
        }
        
        let beautifyStartDate = this.value.recurrence.startDate.split('T')[0];
        let beautifyEndDate;
        if(this.localRecurrence.endDate != null ) {
            beautifyEndDate = dateutil.uGetDateFormat('yyyy-MM-dd', dateutil.IEDate(this.localRecurrence.endDate));
        }
        
        let display: string = '';
        
        if(this.localRecurrence.ui_recurringType == 1) {
            if(this.localRecurrence.endDate != null)    
            {
                // 매일 / 종료일 특정 날짜
                //display = `${beautifyEndDate} 까지 ${this.localRecurrence.interval}일 마다 반복`;
                display = this.$t('종료일까지_N일마다_반복', {endDate: beautifyEndDate, interval: this.localRecurrence.interval}).toString();
            }
            else
            {
                // 매일 / 종료일 기한 없음
                //display = `${this.localRecurrence.interval}일 마다 반복`;
                display = this.$t('N일마다_반복', {interval: this.localRecurrence.interval}).toString();
            }
        }
        //매주
        else if(this.localRecurrence.ui_recurringType == 2) {
            // 반복일정 수정할 때 요일 체크한거 화면에 display
            this.showWeekText  = this.weeklist.filter((x:any) => 
                (this.localRecurrence.daysOfTheWeekArray?.indexOf(x.value) != -1)                   
            ).map((x) => {return x.text;}).join(',');

            //this.showWeekText = weekArrayString;

            if(this.localRecurrence.endDate != null)
            {
                // 매주 / 종료일 특정 날짜
                //display = `${beautifyEndDate} 까지 ${this.localRecurrence.interval}주마다 ${this.showWeekText} 반복`;
                display = this.$t('종료일까지_N주마다_반복', {endDate: beautifyStartDate, interval: this.value.recurrence.interval, weekText: this.showWeekText}).toString();
            }
            else 
            {
                // 매주 / 종료일 기한 없음
                //display = `${this.localRecurrence.interval}주마다 ${this.showWeekText} 에 반복`;
                display = this.$t('N주마다_반복', {interval: this.value.recurrence.interval, weekText: this.showWeekText}).toString();
            }
        }
        //매월
        else if(this.localRecurrence.ui_recurringType == 3) {
            if(this.localRecurrence.endDate != null)
            {
                // 매월 / 종료일 특정 날짜
                //display = `${beautifyEndDate} 까지 ${this.localRecurrence.interval}개월마다 ${this.localRecurrence.dayOfMonth}일에 반복`;
                display = this.$t('종료일까지_N개월마다_반복', {endDate: beautifyStartDate, interval: this.value.recurrence.interval, day: this.localRecurrence.dayOfMonth}).toString();
            }
            else 
            {
                // 매월 / 종료일 기한 없음
                //display = `${this.localRecurrence.interval}개월마다 ${this.localRecurrence.dayOfMonth}일에 반복`;
                display = this.$t('N개월마다_반복', {interval: this.value.recurrence.interval, day: this.localRecurrence.dayOfMonth}).toString();
            }
        }
        //매년
        else if(this.localRecurrence.ui_recurringType == 4) {
            if(this.localRecurrence.endDate != null)
            {
                // 매년 / 종료일 특정 날짜
                //display = `${beautifyEndDate} 까지 매년 ${this.localRecurrence.monthValue}월 ${this.localRecurrence.dayOfMonth}일마다 반복`;
                display = this.$t('종료일까지_N년마다_반복', {endDate: beautifyStartDate, month: this.localRecurrence.monthValue, day: this.localRecurrence.dayOfMonth}).toString();
            }
            else 
            {
                // 매년 / 종료일 기한 없음
                //display = `매년 ${this.localRecurrence.monthValue}월 ${this.localRecurrence.dayOfMonth}일마다 반복`;
                display = this.$t('N년마다_반복', {month: this.localRecurrence.monthValue, day: this.localRecurrence.dayOfMonth}).toString();
            }
        }
  
        if (!this.value.isEWS) {
            this.value.pidLidRecurrencePattern = display;
        }
        return display;
    }

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    /**
     * 반복일정 사용 안 함 클릭 이벤트
     */
    notUsingRecurring() {
        this.isNotUsed = true
        this.typeChangeOpen = false
    }

    /**
     * 반복일정 타입 클릭 이벤트
     */
    passRecurringType(value: string) {
        this.isNotUsed = false
        this.typeChangeOpen = false
        this.RecurringType = value
    }

    //반복일정을 설정한다 ***( 유효성 검사 )***
    async save() {
        // 반복일정 설정 안함은 유효성 검사 X
        if (this.isNotUsed) {
            this.localRecurrence = {} as calendar.CalendarItemRecurrence
        } else {
            //let selectedValue = dateutil.getDurationFromText(this.durationDispalyText);
            let checkday: number = 0;
            let valid: string = '';
            this.localRecurrence.startDate = dateutil.DateAndTimeSplitor(this.localRecurrence.startDate)[0];
            this.localRecurrence.endDate = dateutil.DateAndTimeSplitor(this.localRecurrence.endDate + '')[0];
            //this.value.start = this.localRecurrence.startDate + '';

            // if (!this.timeChanged(dateutil.getDurationFromText(this.durationDispalyText), true)) {
            //     return;
            // }
            //let checkedArray = this.WeekCheckboxArray.filter((x) => x.flag).map((x) => x.value);

            if (this.localRecurrence.ui_endType == '3' && dateutil.IEDate(this.localRecurrence.endDate) < dateutil.IEDate(this.localRecurrence.startDate)) {
                //valid = '반복 종료일자가 반복 시작일자보다 빠를 수 없습니다';
                valid = this.$t('M_Schedule_FastRepeatEnd').toString();
            }
            else if (!this.localRecurrence.interval || this.localRecurrence.interval <= 0) {
                //valid ='주기는 1 이상 지정해야 합니다';
                valid = this.$t('M_Schedule_LowInterval').toString();
            }
            else if (dateutil.IEDate(this.value.end + 'T' + this.value.endtime) < dateutil.IEDate(this.value.start + 'T' + this.value.starttime)) {
                //valid = '종료일자가 시작일자보다 빠를 수 없습니다';
                valid = this.$t('M_Schedule_FastEnd').toString();
            }
            // else if (this.localRecurrence.ui_recurringType == 2 && !checkedArray.length) {
            //     valid = '요일을 1개 이상 선택해 주세요';
            // }
            else if (this.localRecurrence.ui_recurringType == 3 && ((this.localRecurrence.dayOfMonth as number) <= 0 || !this.localRecurrence.dayOfMonth)) {
                //valid = '월별 날짜는 1 이상 지정해야 합니다';
                valid = this.$t('M_Schedule_SelectMonthDay').toString();
            }

            // 매주
            else if (this.localRecurrence.ui_recurringType == 2) {
                let copyCheckedArray = [] as number[];
                //매주 - 요일 1개 체크 시 (배열 붙여서 비교) 
                //Object.assign(copyCheckedArray, checkedArray.map((x) => x + 7));
                //let validCheckedArray = [...checkedArray, ...copyCheckedArray];
                // 매주 - 요일 2개 이상 체크 시
                // ex) 체크한 요일에 대한 배열이 [일, 월, 목, 금] -> [0, 1, 4, 5] 일 경우 Bubble sort 처럼 빼서 비교
                // 뺄 때 마다 selectedValue.totalDays랑 비교해서 유효성 검사
                /*
                if (validCheckedArray.length > 2) {
                    for (let i = 0; i < validCheckedArray.length - 1; i++) {
                        checkday = validCheckedArray[i + 1] - validCheckedArray[i];
                        if (checkday < selectedValue.totalDays) {
                            valid = '기간이 너무 깁니다';
                            break;
                        }
                    }
                }
                */
            }
            //매월일 경우
            //29일 이상은 '월의 마지막일로 계산된다'라는 안내창
            else if (this.RecurringType == '3') {
                if ((this.localRecurrence.dayOfMonth as number) >= 29) {
                    //await(window as any).confirmAsync('29일 이상은 월의 마지막일로 계산됩니다.');
                    await(window as any).confirmAsync(this.$t('M_Schedule_LastMonth').toString());
                }
            }
            
            if (valid) {
                await(window as any).alertAsync(valid);
                return;
            }

            this.localRecurrence.ui_useDefaultDate = false;
            this.localRecurrence.ui_useRecurringDisplay = true;
            this.localRecurrence.ui_useRecurring = true;

            //this.localRecurrence.daysOfTheWeekArray = checkedArray;
            if (this.localRecurrence.endDate == 'null') {
                this.localRecurrence.endDate = null;
            }

            if (this.localRecurrence.numberOfOccurrences == 0) {
                this.localRecurrence.numberOfOccurrences = null;
            }
        }

        this.value.recurrence = this.localRecurrence

        //this.setCurrentItem(this.value);
        //this.setCurrentRecurring(this.value.recurrence);
        this.$router.push({
            path: '/calendar/write',
            query: {pvalue: encodeURIComponent(JSON.stringify(this.value))}
        });
    }

    setEndDate(date: string | null, type: string, count: number) {
        this.localRecurrence.endDate = date
        this.localRecurrence.ui_endType = type
        this.localRecurrence.numberOfOccurrences = count
        this.showEndDateModal = false
    }

    setDay(dayArray: any) {
        this.localRecurrence.daysOfTheWeekArray = dayArray
        this.showWeekText = this.weeklist.filter((x:any) => 
            (this.localRecurrence.daysOfTheWeekArray?.indexOf(x.value) != -1)                   
        ).map((x) => {return x.text;}).join(',');
        this.showDayModal = false
    }

    @Watch("RecurringType")
    onRecurringTypeChanged(cvalue: any) {
        this.localRecurrence.ui_recurringType = Number(cvalue) as  1 | 2 | 3 | 4;
    }

    //
    // ────────────────────────────────────────────────────────── I ──────────
    //   :::::: L I F E C Y C L E : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────────
    //

    mounted() {
        if (!this.value.recurrence.hasEnd) {
            this.value.recurrence.ui_endType = '1';
        }
        else {
            if (this.value.recurrence.numberOfOccurrences != null) {
                this.value.recurrence.ui_endType = '2';
            }
            if (this.value.recurrence.endDate != null) {
                this.value.recurrence.ui_endType = '3';
            }
        }

        if(this.localRecurrence.ui_useRecurring === false){
            this.notUsingRecurring;
        }

        if(this.localRecurrence.daysOfTheWeekArray){
            this.showWeekText = this.weeklist.filter((x:any) => 
            (this.value.recurrence.daysOfTheWeekArray?.indexOf(x.value) != -1)                   
            ).map((x) => {return x.text;}).join(',');
        }

        if(this.localRecurrence.ui_useRecurring === false) {
            this.localRecurrence.ui_endType == '';
            this.localRecurrence.endDate = null;
            this.localRecurrence.interval == null;
        }
    }
}
